export const WIDTH = 1056;
export const HEIGHT = 816;

export const HITTER_TYPE_LABELS = {
  pull: "Pull Hitter",
  all_fields: "All Fields",
  oppo: "Opposite Field",
};

